import { Button } from '@mui/material';

type Props = {
  isRunMode: boolean;
  label: 'On' | 'Off';
  isTriplexPump: boolean;
  isMobile?: boolean;
};
export const PumpModeLabel = ({ isRunMode, label, isTriplexPump, isMobile }: Props) => (
  <Button
    sx={{
      isplay: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      height: isTriplexPump ? (isMobile ? '20px' : '30px') : '36px',
      background: isRunMode ? 'rgba(5, 182, 178, 0.08)' : 'rgba(145, 158, 171, 0.08)',
      borderRadius: '8px',
      fontFamily: 'Public Sans',
      fontStyle: 'normal',
      fontWeight: label === 'Off' ? 600 : 700,
      fontSize: isTriplexPump ? '12px' : '14px',
      lineHeight: '24px',
      width: isTriplexPump ? '30px' : '40px',
      minWidth: isTriplexPump ? '30px' : '40px',
      color: isRunMode ? '#05B6B2' : '#212B36',
      margin: '0 1rem',
      '&:hover': {
        cursor: 'pointer',
        background: isRunMode ? 'rgba(5, 182, 178, 0.08)' : 'rgba(145, 158, 171, 0.08)',
        boxShadow: isRunMode
          ? '0 8px 16px 0 rgba(5, 182, 178, 0.24)'
          : '0 8px 16px 0 rgba(145, 158, 171, 0.08)',
      },
    }}
  >
    {label}
  </Button>
);
